import { Injectable } from "@angular/core";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { SplashFormComponent } from "./splash-form.component";
import { take } from "rxjs/operators";
import { Observable } from "rxjs";
export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

export function isNumber(value: any) {
  return typeof value === "number";
}

@Injectable({ providedIn: "root" })
export class SplashFormService {
  constructor(private dialogService: SimpleModalService) {}
  openDialog(title: string = "", loadingMessage: string = "در حال بارگذاری اطلاعات.....") {
    if (isNullOrUndefined(loadingMessage)) loadingMessage = "در حال بارگذاری اطلاعات.....";
    this.dialogService
      .open(SplashFormComponent, { title: title, errorMessage: loadingMessage , hasCancelButton: false}, { autoFocus: true, closeOnClickOutside: false })
      .pipe(take(1))
      .subscribe((flag) => {});
  }
  openDialogwithCancelButton(title: string = "", loadingMessage: string = "در حال بارگذاری اطلاعات....."): Observable<any> {
    return this.dialogService
      .open(
        SplashFormComponent,
        { title: title, errorMessage: loadingMessage, hasCancelButton: true },
        { autoFocus: true, closeOnClickOutside: false }
      )
      .pipe(take(1));
  }

  closeLoading() {
    try {
      this.dialogService.removeAllLoading();
    } catch (e) {}
  }

  close() {
    this.dialogService.removeModal(new SplashFormComponent());
  }
}
